module.exports = __webpack_public_path__ + "static/img/newlogo.13c36e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newlogo.png
// module id = yOdc
// module chunks = 0